import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleDown, faCommentAlt, faEye, faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import {  useNavigate, useParams } from 'react-router-dom'
import { useGetMessagesQuery, useMarkCommentsCompleteMutation } from '../messageApiSlice'
import { memo, useState } from 'react'
import useAuth from "../../../hooks/useAuth"
import TimeLeft from '../../../partial/TimeLeft'
import ReactQuill from 'react-quill';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { Badge, Box } from '@mui/material'
import MessageComments from '../MessageComments'

const AdminMessage = ({ message }) => {
    const {groupId} = useParams()
    const { isTeacher, isAdmin, isStudent } = useAuth()
    const [expanded, setExpanded] = useState(false);
    const [markCommentComplete, {
      isLoading,
      isSuccess,
      isError,
      error
  }] = useMarkCommentsCompleteMutation()
  const navigate = useNavigate()

  if (message) {

    const numMessages = message.comments?.length ;
    const unReadMessages = message.comments?.filter(comment=>comment.complete===false)||[]
       
    const handleChange = (e)=>{
      if(!expanded && unReadMessages.length > 0 ){
        markCommentComplete({messageId:message._id})
      }
      setExpanded(!expanded)
    }


  

   
       
     
   
  
        return (
<div>

<Accordion onChange={handleChange}  className='accordion-header accordion-root'    style={{background:"transparent", "color":"white", "marginTop":"5px", marginBottom:"10px"}}>
        <AccordionSummary
      
          expandIcon={<FontAwesomeIcon color='white' icon={faArrowAltCircleDown} />}
          aria-controls="panel1a-content"
          style={{}}
        >
          <Typography  >{message.title} 
           <Badge showZero={false} style={{marginRight:"20px"}} badgeContent={unReadMessages.length} color="primary">
<FontAwesomeIcon icon={faCommentAlt} />
</Badge> </Typography>
        </AccordionSummary>
        <AccordionDetails  >
            <Box>
        <ReactQuill
                     theme='bubble'
                    readOnly
                    value={ message.body}
                    
                    ></ReactQuill>
                    </Box>

  <MessageComments message={message} /> 
        </AccordionDetails>
      </Accordion>

   


                 
</div>



           
        )

    } else return null
}

const memoizedMessage = memo(AdminMessage)

export default memoizedMessage